import { API_ENDPOINTS } from "../../enums/apiUrls";

export const reRunAuthOnFileCheck = async (body: {
  patient_mrn: string;
  drug_name: string;
  identifier: string;
  org_id: string;
}) => {
  const url = API_ENDPOINTS.AUTH_ON_FILE_CHECK;
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Failed to re-run auth on file check");
  }

  return response.json();
};
